import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { MeetingRoutes } from './Routes';
import { useTranslation } from 'react-i18next';

export const Meetings = () => {
  const { t } = useTranslation();
  return (
    <>
      <DocumentHead title={t('Meetings')} />
      <PageTemplate main={<MeetingRoutes />} />
    </>
  );
};
